import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import './styles/App.scss'
import 'bootstrap/dist/css/bootstrap.min.css';
import './fonts/Heebo/Heebo-Regular.ttf';
import './fonts/Heebo/Heebo-Bold.ttf';
import './fonts/Heebo/Heebo-Thin.ttf';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
reportWebVitals();
